import { IStore } from 'store/configureStore';

export const selectConfigurationThemeById = (id: string) => (state: IStore) =>
    state.clients.configurationThemeByClientId[id];
export const selectClientLogoUrlById = (id: string) => (state: IStore) =>
    selectConfigurationThemeById(id)(state)?.theme?.logo_url;
